var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup"
    },
    [
      _c("div", { staticClass: "lite_popup_box lite_backup_files" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.files.length) +
                " " +
                _vm._s(_vm.$t("language.common.transferFiles")) +
                " ( " +
                _vm._s(_vm.formatBytes(_vm.totalSize)) +
                " )"
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                _vm.show = false
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite_popup_content" },
          [
            _c(
              "el-table",
              {
                ref: "fileTable",
                staticClass: "lite_backup_files_table",
                attrs: {
                  data: _vm.pagedFiles,
                  border: "",
                  "highlight-current-row": "",
                  height: "550px",
                  "empty-text": " "
                }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "50px" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("language.common.path"),
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.path))])]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("language.common.name"),
                    "show-overflow-tooltip": "",
                    width: "350px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("language.common.size"),
                    width: "100px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatBytes(scope.row.size)))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "20px" } },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, prev, pager, next",
                    total: _vm.files.length,
                    "page-size": _vm.pageSize,
                    "current-page": _vm.currentPage
                  },
                  on: { "current-change": _vm.handlePageChange }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa86ef5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa86ef5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_backup_files.vue
// module id = null
// module chunks = 